import React, { useState } from "react";
import { Link } from "react-router-dom";

import Button from "component/Button/Button";
import useScreenMobile from "hooks/useScreenMobile";

import theTimes from "../../assets/images/blogs/theTimes.png";
import wearable from "../../assets/images/blogs/wearable.png";
import healthCare from "../../assets/images/blogs/healthCare.png";
import sharkTank from "../../assets/images/blogs/sharkTank.png";
import moneyControl from "../../assets/images/blogs/moneyControl.png";
import fashion from "../../assets/images/blogs/fashion.png";
import business from "../../assets/images/blogs/business.png";

import timesImage from "../../assets/images/blogs/timesImage.png";
import entrepreneurImage from "../../assets/images/blogs/entrepreneurImage.png";
import expressImage from "../../assets/images/blogs/expressImage.png";
import mashableImage from "../../assets/images/blogs/mashableImage.png";
import controlImage from "../../assets/images/blogs/controlImage.png";
import fashionImage from "../../assets/images/blogs/fashionImage.png";
import businessToday from "../../assets/images/blogs/businessToday.png";

import "./blogs.scss";

const blogData = [
  {
    id: 1,
    image: theTimes,
    newsImage: timesImage,
    content: (
      <p>
        Imagine a world where humans can enhance their memory, decision-making,
        and productivity with a simple <span>read more...</span>
      </p>
    ),
    readMore:
      "https://timesofindia.indiatimes.com/tv/news/hindi/shark-tank-india-4-pitchers-dhananjay-and-aryan-yadav-bring-their-revolutionary-ai-powered-wearable-former-says-the-support-we-received-from-anupam-mittal-was-a-true-validation/amp_articleshow/117207963.cms"
  },
  {
    id: 2,
    image: wearable,
    newsImage: entrepreneurImage,
    content: (
      <p>
        NeoSapien, a wearable technology startup, has raised INR 80 Lakhs on
        Shark Tank India Season 4. The investment, <span>read more...</span>
      </p>
    ),
    readMore:
      "https://www.entrepreneur.com/en-in/news-and-trends/neosapien-secures-inr-80-lakhs-on-shark-tank-india-4-for-ai/485509"
  },
  {
    id: 3,
    image: healthCare,
    newsImage: expressImage,
    content: (
      <p>
        Shark Tank India pitchers who created &apos;Iron Man ka Jarvis&apos;
        pique &apos;healthcare queen&apos; Namita Thapar&apos;s interest, get
        called &apos;paapi&apos; <span>read more...</span>
      </p>
    ),
    readMore:
      "https://indianexpress.com/article/entertainment/television/shark-tank-india-neosapien-pitch-namita-thapar-anupam-mittal-9777885/"
  },
  {
    id: 4,
    image: sharkTank,
    newsImage: mashableImage,
    content: (
      <p>
        In the latest episode of &apos;Shark Tank India&apos; Season 4, a
        dynamic duo, Dhananjay and Aryan, founders of NeoSapien,{" "}
        <span>read more...</span>
      </p>
    ),
    readMore:
      "https://in.mashable.com/culture/88101/namita-thapar-backs-shark-tank-pitchers-for-iron-man-ka-jarvis-anupam-mittal-calls-them-paapi-for-th"
  },
  {
    id: 5,
    image: moneyControl,
    newsImage: controlImage,
    content: (
      <p>
        Bengaluru-based generative artificial intelligence-powered wearable
        startup NeoSapien has <span>read more...</span>
      </p>
    ),
    readMore:
      "https://www.moneycontrol.com/news/business/startup/neosapien-bags-rs-80-lakh-from-emcure-s-namita-thapar-in-shark-tank-india-12910524.html"
  },
  {
    id: 6,
    image: fashion,
    newsImage: fashionImage,
    content: (
      <p>
        &apos;I don&apos;t just back good ideas- I back bold ones,&apos; said
        NeoSapien&apos;s founding advisor Anupam Mittal in a press release{" "}
        <span>read more...</span>
      </p>
    ),
    readMore:
      "https://in.fashionnetwork.com/news/Neosapien-receives-rs-80-lakh-investment-for-ai-wearables-brand,1692110.html"
  },
  {
    id: 7,
    image: business,
    newsImage: businessToday,
    content: (
      <p>
        NeoSapien, a wearable tech startup co-founded by Dhananjay Yadav and
        Aryan Yadav in 2024, has unveiled Neo 1, <span>read more...</span>
      </p>
    ),
    readMore:
      "https://www.businesstoday.in/technology/news/story/neosapien-unveils-an-ai-native-wearable-secures-rs-80-lakh-shark-tank-investment-460910-2025-01-15"
  }
];

const Blogs = () => {
  const isMobile = useScreenMobile({ size: 568 });
  const [cardsView, setCardsView] = useState(3);

  return (
    <section className="container newsContainer common-padding">
      <div className="common-heading">
        <h1>Latest News on Neo 1</h1>
      </div>
      <div className="newsSection">
        {blogData.map((item, index) => {
          if (!isMobile || index < cardsView) {
            return (
              <div key={item.id} className="newsCard">
                <Link className="linkWrap" to={item.readMore} target="_blank">
                  <div className="news-img">
                    <img
                      src={item.image}
                      alt="vectorimage"
                      className="vectorImage"
                    />
                  </div>
                  <div className="newsDetails">
                    <img src={item.newsImage} alt="news source" />
                    <p className="newsConent">
                      {item.content}
                      {/* <span> read more...</span> */}
                    </p>
                  </div>
                </Link>
              </div>
            );
          }
          return null;
        })}
      </div>
      {isMobile && (
        <div
          className="buttonBox"
          onClick={() => setCardsView(cardsView === 3 ? blogData.length : 3)}
        >
          <Button title={cardsView === 3 ? "View More" : "View Less"} />
        </div>
      )}
    </section>
  );
};

export default Blogs;
